// src/app/services/cognition-api.ts
import { apiFetch } from "@/api/api-fetch";
import type { CognitionCandidatesResponse } from "./cognition-service";

export async function fetchCognitionCandidates(brand: string): Promise<CognitionCandidatesResponse> {
  return apiFetch<CognitionCandidatesResponse>(
    `/cognition/brand-candidates?brand=${encodeURIComponent(brand)}`,
  );
}
